export enum ApplicationConnectStatus {
    NotConnected = 1,
    Connected = 2
}